import { FC } from 'react';
import classNames from 'classnames';

import { ImageFade } from '../imageFade/ImageFade';

import style from './ProviderImage.module.css';

interface Props {
  className?: string;
  src?: string;
  size?: 'normal' | 'large';
  squareish?: boolean;
}

export const ProviderImage: FC<Props> = ({ className, src, size = 'normal', squareish = false }) => {
  if (!src) {
    return null;
  }

  return (
    <ImageFade
      src={src}
      alt=""
      className={classNames(style[size], className, {
        [style.squareish]: squareish,
      })}
    />
  );
};
